import { AccountCheckOutlineIcon } from './AccountCheckOutlineIcon';

/**
 * author: Google
 * id 50F80B8D-C424-4FC1-9A2E-81715787C240
 * name account-check-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-check-outline.svg
 * tags
 * - Account / User 
 */
export const UserTickOutlineIcon = AccountCheckOutlineIcon;
export default UserTickOutlineIcon